export const enum StepOrders {
    BrandPublication = 1,
    MarketSubmission = 2,
    FinalAllocationSubmission = 3,
}
